


















































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
  },
})
export default class CamaraVODVerDetalle extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: {} }) dataTraza!: any;

  showInfo: boolean = true;
  objectHeader: any = {};
  listEvents: any[] = [];

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Detalle - Información General',
      visible: true,
      step: 1,
    },
  };

  mounted() {
    this.objectHeader = { ...this.dataTraza.header };
    this.listEvents = [...this.dataTraza.eventos];
  }

  handleCerrar() {
    this.$emit('cerrar');
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
}
